import { useCallback, useState } from "react";
import { UseDeleteProps } from "./types";
import { DELETE_QUERY, DeleteGql } from "../queries/delete";
import { ApiAuthRequest } from "data/ApiForm";

const useDelete = ({ queryParam, setSnackBarInfo, setEditing }: UseDeleteProps) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteError = (e: any) => {
    const stackError =
      e?.response?.data?.errors?.[0]?.extensions?.error?.stack ||
      e?.extensions?.error?.stack ||
      e?.message ||
      "";
    if (stackError?.includes("Foreign key constraint violated")) {
      return setSnackBarInfo({
        open: true,
        color: "error",
        title: "Ops, Não pode excluir esse Formulário",
        content:
          "Esse formulário possuí respostas e não pode ser excluído. Exclua todas as respostas antes ou apenas desative ele",
        autoHideDuration: null,
      });
    }

    setSnackBarInfo({
      open: true,
      color: "error",
      title: "Ops, algo deu errado",
      content: e?.message || "Ops. Algo Deu errado",
      autoHideDuration: null,
    });
  };

  const handleDeleteSuccess = () => {
    setEditing(false);
    setSnackBarInfo({
      open: true,
      color: "success",
      icon: "check",
      autoHideDuration: null,
      title: "Deletado com sucesso",
      redirectid: -1,
    });
  };

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ApiAuthRequest<DeleteGql>({
        query: DELETE_QUERY,
        variables: { id: queryParam },
      });

      if (!response?.data?.data?.deleteForm?.id) {
        console.log("aqui 1");
        if (response.data?.errors?.[0]) throw response.data?.errors?.[0];
        throw new Error(JSON.stringify(response?.data || "Algo deu errado!"));
      }

      handleDeleteSuccess();
      setLoading(false);
    } catch (error: any) {
      console.log("aqui 2");
      console.error(error);
      setLoading(false);
      handleDeleteError(error);
    }
  }, [queryParam]);

  return {
    handleDelete,
    handleDeleteSuccess,
    handleDeleteError,
  };
};

export default useDelete;
